import { render, staticRenderFns } from "./EcommerceAssentCard.vue?vue&type=template&id=2a674896&"
import script from "./EcommerceAssentCard.vue?vue&type=script&lang=js&"
export * from "./EcommerceAssentCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports